import apiClient from "@/lib/api/client";
import { createApiRequest } from "@/lib/api/createApiService";
import { ORGANIZATION_ENDPOINTS } from "./organization.endpoints";

export const organizationService = {
  fetchHierarchy: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.LIST,
      method: "GET",
      ...options,
    });
  },

  fetchLookups: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.LOOKUPS,
      method: "GET",
      ...options,
    });
  },

  fetchNames: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.NAMES,
      method: "GET",
      ...options,
    });
  },

  fetchTree: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.TREE,
      method: "GET",
      ...options,
    });
  },

  fetchHierarchyAdminAll: async (options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.HIERARCHY_ADMIN_ALL,
      method: "GET",
      ...options,
    });
  },

  createUnit: async (payload, options = {}) => {
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateUnit: async (unitId, payload, options = {}) => {
    if (!unitId) throw new Error("unitId is required");
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.UPDATE(unitId),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  deleteUnit: async (unitId, options = {}) => {
    if (!unitId) throw new Error("unitId is required");
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.DELETE(unitId),
      method: "DELETE",
      ...options,
    });
  },

  setStatus: async (unitId, status, options = {}) => {
    if (!unitId) throw new Error("unitId is required");
    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.SET_STATUS(unitId),
      method: "PATCH",
      body: { status },
      ...options,
    });
  },

  downloadImportTemplate: async ({ companyId, level } = {}) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    if (level) params.level = level;

    const { data } = await apiClient.get(
      ORGANIZATION_ENDPOINTS.IMPORT_TEMPLATE,
      {
        params,
        responseType: "blob",
      },
    );
    return data;
  },

  importUnitsExcel: async (formData, options = {}) => {
    if (!formData) throw new Error("formData is required");

    return createApiRequest({
      url: ORGANIZATION_ENDPOINTS.IMPORT_EXCEL,
      method: "POST",
      body: formData,
      isFormData: true,
      ...options,
    });
  },
};
